import * as React from 'react';
import { Panel } from '@ixicare/ui';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import { DrawTool } from '~modules/draw-tool';
import BackLink from '~components/BackLink';
import { t } from '~i18n';

interface SiteFloorUpdateProps extends SiteWrapperProps {
  planeId: number;
}

const SiteFloorUpdatePage: React.FC<SiteFloorUpdateProps> = ({ site, planeId }) => {
  return (
    <Panel>
      <DrawTool
        site={site}
        planeId={planeId}
        headerSlot={
          <BackLink fallbackUrl={`/sites/${site.uuid}#floors`} name={t('site.crumbs.backTo', { name: site.name })} />
        }
      />
    </Panel>
  );
};

// The editor covers the viewport, so the wrapper's chrome would be invisible; the sidebar
// carries a back link instead — there is no room for the full trail beside it.
export default siteWrapper(
  SiteFloorUpdatePage,
  ({ query }) => {
    const { planeId } = query;
    return {
      planeId: parseInt(planeId, 10),
    };
  },
  { detachChrome: true }
);
